import React from 'react';

const ChainShotLogo = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 217 52' width={100}>
      <g>
        <title>Chainshot</title>
        <g id='svg_1'>
          <g id='svg_2'>
            <path
              id='svg_3'
              d='m51.683,24.563c0,-6.957 5.234,-11.651 12.022,-11.651c4.931,0 7.801,2.668 9.389,5.504l-4.12,2.026c-0.946,-1.823 -2.971,-3.276 -5.268,-3.276c-4.12,0 -7.092,3.141 -7.092,7.396s2.972,7.396 7.092,7.396c2.297,0 4.323,-1.452 5.268,-3.276l4.12,1.993c-1.588,2.802 -4.458,5.538 -9.389,5.538c-6.787,0.001 -12.022,-4.727 -12.022,-11.65z'
              fill='#333333'
            ></path>
            <path
              id='svg_4'
              d='m86.911,35.809l0,-9.928c0,-2.263 -1.181,-2.972 -3.006,-2.972c-1.688,0 -3.006,0.946 -3.715,1.892l0,11.009l-4.323,0l0,-22.525l4.323,0l0,8.307c1.047,-1.216 3.04,-2.499 5.707,-2.499c3.58,0 5.302,1.958 5.302,5.133l0,11.583l-4.288,0z'
              fill='#333333'
            ></path>
            <path
              id='svg_5'
              d='m106.671,35.809l0,-2.094c-1.283,1.621 -3.039,2.499 -5.032,2.499c-4.086,0 -7.227,-3.107 -7.227,-8.578c0,-5.302 3.073,-8.544 7.227,-8.544c1.925,0 3.715,0.81 5.032,2.499l0,-2.094l4.323,0l0,16.311l-4.323,0l0,0.001zm0,-5.269l0,-5.74c-0.709,-1.081 -2.263,-1.892 -3.681,-1.892c-2.465,0 -4.154,1.925 -4.154,4.728c0,2.837 1.688,4.761 4.154,4.761c1.418,0.001 2.971,-0.776 3.681,-1.857z'
              fill='#333333'
            ></path>
            <path
              id='svg_6'
              d='m114.848,15.175c0,-1.418 1.148,-2.533 2.533,-2.533c1.419,0 2.567,1.115 2.567,2.533c0,1.419 -1.148,2.567 -2.567,2.567c-1.385,-0.001 -2.533,-1.149 -2.533,-2.567zm0.404,20.634l0,-16.311l4.289,0l0,16.311l-4.289,0z'
              fill='#333333'
            ></path>
            <path
              id='svg_7'
              d='m134.807,35.809l0,-9.861c0,-2.263 -1.181,-3.04 -3.005,-3.04c-1.688,0 -2.972,0.946 -3.715,1.892l0,11.009l-4.289,0l0,-16.311l4.289,0l0,2.094c1.047,-1.216 3.073,-2.499 5.707,-2.499c3.614,0 5.335,2.026 5.335,5.2l0,11.516l-4.322,0z'
              fill='#333333'
            ></path>
            <path
              id='svg_8'
              d='m141.903,32.634l2.634,-3.748c1.586,1.654 4.051,3.073 7.158,3.073c2.668,0 3.918,-1.182 3.918,-2.499c0,-3.917 -12.968,-1.181 -12.968,-9.658c0,-3.748 3.242,-6.855 8.543,-6.855c3.58,0 6.552,1.081 8.782,3.14l-2.668,3.58c-1.823,-1.688 -4.256,-2.465 -6.552,-2.465c-2.026,0 -3.174,0.878 -3.174,2.229c0,3.546 12.934,1.148 12.934,9.557c0,4.12 -2.972,7.227 -9.017,7.227c-4.355,-0.001 -7.463,-1.453 -9.59,-3.581z'
              fill='#FF8622'
            ></path>
            <path
              id='svg_9'
              d='m174.665,35.809l0,-9.928c0,-2.263 -1.183,-2.972 -3.006,-2.972c-1.688,0 -3.005,0.946 -3.715,1.892l0,11.009l-4.323,0l0,-22.525l4.323,0l0,8.307c1.047,-1.216 3.04,-2.499 5.707,-2.499c3.58,0 5.302,1.958 5.302,5.133l0,11.583l-4.288,0z'
              fill='#FF8622'
            ></path>
            <path
              id='svg_10'
              d='m182.166,27.636c0,-4.627 3.242,-8.544 8.611,-8.544c5.403,0 8.645,3.917 8.645,8.544s-3.242,8.578 -8.645,8.578c-5.369,0 -8.611,-3.951 -8.611,-8.578zm12.799,0c0,-2.533 -1.485,-4.728 -4.188,-4.728c-2.667,0 -4.154,2.195 -4.154,4.728c0,2.567 1.487,4.761 4.154,4.761c2.703,0.001 4.188,-2.194 4.188,-4.761z'
              fill='#FF8622'
            ></path>
            <path
              id='svg_11'
              d='m203.514,31.723l0,-8.476l-2.702,0l0,-3.749l2.702,0l0,-4.458l4.289,0l0,4.458l3.309,0l0,3.749l-3.309,0l0,7.328c0,1.047 0.54,1.823 1.485,1.823c0.642,0 1.25,-0.236 1.485,-0.506l0.913,3.275c-0.642,0.574 -1.791,1.047 -3.58,1.047c-3.006,0 -4.592,-1.553 -4.592,-4.491z'
              fill='#FF8622'
            ></path>
          </g>
          <g id='svg_12'>
            <path
              id='svg_13'
              d='m33.254,30.104c-2.034,4.302 -6.4,7.286 -11.475,7.286c-7.014,0 -12.7,-5.686 -12.7,-12.7c0,-7.014 5.686,-12.7 12.7,-12.7c5.075,0 9.442,2.984 11.475,7.287l6.069,0c0.97,0 1.869,0.306 2.614,0.825l0,-7.05l-20.158,-11.638l-20.159,11.638l0,23.278l20.158,11.638l20.158,-11.638l0,-6.275l0,-0.775c-0.745,0.519 -1.644,0.825 -2.614,0.825l-6.068,0l0,-0.001z'
              fill='#FF8622'
            ></path>
            <path
              id='svg_14'
              d='m39.323,22.269l-5.082,0c0.152,0.785 0.237,1.593 0.237,2.422c0,0.829 -0.085,1.638 -0.237,2.422l5.082,0c0.931,0 1.687,-0.768 1.687,-1.712l0,-1.42c0,-0.944 -0.756,-1.712 -1.687,-1.712z'
              fill='#FF8622'
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ChainShotLogo;
